const { stripUndefined } = require('../utils');

const INITIAL_STATE = {
  items: [],
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
  didInvalidate: false,
  hasMore: true,
  limit: 16,
};

const mapNewsItem = (item) =>
  stripUndefined({
    _id: item._id,
    title: item.title,
    description: item.description,
    type: item.type,
    text: item.text,
    full_text: item.full_text,
    url: item.url,
    permalink_url: item.permalink_url,
    pubdate: item.pubdate,
    media: item.media,
    extended_entities: item.extended_entities,
    entities: item.entities,
    content: item.content,
    contentType: item.contentType,
    thumbnail: item.thumbnail || item?.thumbnails?.medium?.url,
    source: item.origin && item.origin.source,
    name: item.origin && item.origin.name,
    // eslint-disable-next-line no-underscore-dangle
    _created: item._created,
  });

const actions = {
  FETCH_IN_PROGRESS: 'FETCH_NEWS_IN_PROGRESS',
  FETCH_SUCCESSFUL: 'FETCH_NEWS_SUCCESSFUL',
  FETCH_FAILED: 'FETCH_NEWS_FAILED',
  INVALIDATE_NEWS: 'INVALIDATE_NEWS',
};

module.exports = function NewsFeedReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_LANGUAGE':
    case actions.INVALIDATE_NEWS: {
      return {
        ...INITIAL_STATE,
        limit: state.limit,
        didInvalidate: true,
      };
    }
    case actions.FETCH_IN_PROGRESS:
      return {
        ...state,
        fetchingInProgressSince: action.timestamp,
      };
    case actions.FETCH_SUCCESSFUL:
      if (state.items.length > action.from) {
        return {
          ...state,
          lastFailedFetch: action.timestamp,
          lastErrorMessage: `Old request, item count:${state.items.length}, request count:${action.from}`,
        };
      }
      if (!state.fetchingInProgressSince) {
        return {
          ...state,
          lastFailedFetch: action.timestamp,
          lastErrorMessage:
            'Redux was not expecting a request, data was invalidated or requests overlaped',
        };
      }
      return {
        ...state,
        items: [...state.items, ...action.items.map(mapNewsItem)],
        lastSuccessfulFetch: action.timestamp,
        fetchingInProgressSince: null,
        hasMore: action.items.length === state.limit,
      };
    case actions.FETCH_FAILED:
      return {
        ...state,
        fetchingInProgressSince: null,
        lastFailedFetch: action.timestamp,
        lastErrorMessage: action.reason,
      };
    default:
      return state;
  }
};

module.exports.actions = actions;
